import { getFormValues, destroy } from 'redux-form';
import http from '../../../shared/http';
import endpoints from '../../../../config/endpoints';

const defaultInitialState = {
	isDailyApprovePopupShowed: false,
	whitelistedIps: []
};

const createForm = () => {
	const namespace = 'unacceptableConversions';

	const TOGGLE_FORM = `${namespace}-toggle-whitelisted-ips-form`;

	const SUBMIT_FORM_OK = `${namespace}-submit-whitelisted-ips-form-ok`;
	const SUBMIT_FORM_FAIL = `${namespace}-submit-whitelisted-ips-form-fail`;

	const FETCH_LIST_OK = `${namespace}-fetch-whitelisted-ips-ok`;
	const FETCH_LIST_NOT_OK = `${namespace}-fetch-whitelisted-ips-not-ok`;

	const DROP_IP_OK = `${namespace}-drop-whitelisted-ip-ok`;

	const initialState = { ...defaultInitialState };

	const actions = {
		toggleWhitelistedIpsForm: () => dispatch => {
			dispatch({ type: TOGGLE_FORM  });
			dispatch(actions.fetchWhitelistedIpsList());
		},
		submitWhitelistedIp: (formData) => (dispatch, getState) => {
			const data = { ...formData };

			return http({
				url: endpoints.CONVERSIONS.WHITELISTED_IPS,
				method: 'post',
				data: data,
				actions: [ SUBMIT_FORM_OK, SUBMIT_FORM_FAIL ]
			})(dispatch).then(action => {
				if (action.type === SUBMIT_FORM_OK) {
					dispatch(destroy('whitelistedIpsForm'));
					dispatch(actions.fetchWhitelistedIpsList());
				}
			});
		},
		fetchWhitelistedIpsList: () => (dispatch, getState) => {
			return http({
				url: endpoints.CONVERSIONS.WHITELISTED_IPS,
				method: 'get',
				actions: [ FETCH_LIST_OK, FETCH_LIST_NOT_OK ]
			})(dispatch);
		},
		removeWhitelistedIp: (ip) => (dispatch, getState) => {
			return http({
				url: endpoints.CONVERSIONS.WHITELISTED_IPS,
				method: 'delete',
				data: { ip },
				actions: [ DROP_IP_OK ]
			})(dispatch)
				.then(() => {
					dispatch(actions.fetchWhitelistedIpsList());
				});
		}
	};

	const reducers = {
		[TOGGLE_FORM]: (state, action) => ({
			...state, isDailyApprovePopupShowed: !state.isDailyApprovePopupShowed
		}),
		[FETCH_LIST_OK]: (state, action) => ({
			...state, whitelistedIps: action.payload.data
		})
	};

	const selectors = {
		getFormData: state => {
			const formValues = getFormValues('approveDailyForm')(state);
			if (!formValues) return {};

			return {
				...formValues,
				offers: formValues.offers && formValues.offers.map(i => i.value),
				countries: formValues.countries && formValues.countries.map(i => i.value),
				affiliate_id: state.affiliateProfile.affiliateId
			};
		}
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createForm;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/statistics/components/whitelisted-ips-form/index.js